import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/autoplay";
import { studyData } from "../../data/home";
import { mediaUrl } from "../../services/assetUrl";
import highlight from "./highlight";
import "./homeRedesign.css";

const StudyFeature = ({ data }) => {
  const { eyebrow, heading, subtitle, articles, highlight: hl } = data || studyData;

  return (
    <section className="study-ed" aria-labelledby="study-ed-title">
      <div className="container">
        <div className="section-head-ed section-head-ed--on-dark">
          <span className="eyebrow-ed eyebrow-ed--on-dark">{eyebrow}</span>
          <h2 id="study-ed-title" className="heading-ed heading-ed--on-dark">{highlight(heading, hl)}</h2>
          <p className="section-sub-ed section-sub-ed--on-dark">{subtitle}</p>
        </div>

        <Swiper
          modules={[Autoplay]}
          autoplay={{ delay: 3000, disableOnInteraction: false, pauseOnMouseEnter: true }}
          speed={700}
          loop={true}
          spaceBetween={26}
          slidesPerView={1}
          breakpoints={{ 600: { slidesPerView: 2 }, 1024: { slidesPerView: 3 } }}
        >
          {articles.map((article) => (
            <SwiperSlide key={article.id}>
              <article className="study-ed__card">
                <div className="study-ed__img">
                  <img src={mediaUrl(article.image)} alt={article.title} loading="lazy" />
                </div>
                <div className="study-ed__body">
                  <h3 className="study-ed__title">{article.title}</h3>
                  <p className="study-ed__text">{article.content}</p>
                </div>
              </article>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>
    </section>
  );
};

export default StudyFeature;
